module.exports = __webpack_public_path__ + "assets/img/tx101_3.a14f4077.jpg";